export default async  (CEP) => {
  let response = await fetch(`https://brasilapi.com.br/api/cep/v1/${CEP}`);
  let address = await response.json();

  return address;
}